module.exports = __webpack_public_path__ + "static/img/building_logo_low_opacity.b0c4427.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/building_logo_low_opacity.png
// module id = 183
// module chunks = 1